import gql from 'graphql-tag';

export const PremiumGateQuery = gql`
	query PremiumGateQuery {
		entitlements {
			premiumExtensions {
				isEntitled
			}
		}
	}
`;
